import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f10cc0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "border mb-6 shadow-lg border-primary-50 bg-white dark:border-dark-400 dark:bg-dark-500",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = {
  class: "px-3 py-3 font-bold border-b bg-primary border-primary-50 text-white dark:bg-dark-400 dark:border-dark-400 dark:text-dark-text",
  style: {"border-radius":"1rem 1rem 0 0"}
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "mx-1 text-lg" }
const _hoisted_5 = { class: "border-b border-gray-300 dark:border-dark-400" }
const _hoisted_6 = { class: "grid grid-cols-4 border-b h-8 text-base font-bold text-gray-800 bg-white dark:text-dark-text dark:bg-dark-500 dark:border-dark-400" }
const _hoisted_7 = { class: "border-r flex justify-center items-center bg-primary-300 text-white border-primary-200 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_8 = { class: "border-r flex justify-center items-center bg-primary-300 text-white border-primary-200 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_9 = { class: "border-r flex justify-center items-center bg-primary-300 text-white border-primary-200 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_10 = { class: "flex justify-center items-center bg-primary-300 text-white border-primary-200 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_11 = {
  key: 0,
  class: "h-8 px-4 mt-2 text-center text-gray-800 bg-white dark:text-dark-text dark:bg-dark-500",
  style: {"border-radius":"0 0 1rem 1rem"}
}
const _hoisted_12 = {
  key: 1,
  class: "h-8 px-4 mt-2 text-center text-gray-800 bg-white dark:text-dark-text dark:bg-dark-500",
  style: {"border-radius":"0 0 1rem 1rem"}
}
const _hoisted_13 = {
  key: 2,
  class: "grid grid-cols-4 h-8 text-base text-gray-800 bg-white dark:text-dark-text dark:bg-dark-500 dark:border-dark-400",
  style: {"border-radius":"0 0 1rem 1rem"}
}
const _hoisted_14 = { class: "border-r flex justify-center items-center dark:border-dark-400" }
const _hoisted_15 = { class: "border-r flex justify-center items-center dark:border-dark-400" }
const _hoisted_16 = { class: "border-r flex justify-center items-center dark:border-dark-400" }
const _hoisted_17 = { class: "flex justify-center items-center dark:border-dark-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_judge_badge = _resolveComponent("judge-badge")!
  const _component_JudgeStep = _resolveComponent("JudgeStep")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('message.RESULT')) + " :", 1),
        (_ctx.judgeRecord && !_ctx.isJudgeLoading)
          ? (_openBlock(), _createBlock(_component_judge_badge, {
              key: 0,
              class: "my-auto",
              status: _ctx.judgeRecord.status
            }, null, 8, ["status"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isJudgeLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["relative h-16 p-4 text-gray-500 bg-white dark:text-dark-text dark:bg-dark-500", _ctx.isLightMode() ? 'loading' : 'loading-dark'])
          }, _toDisplayString(_ctx.$t('message.loading')), 3))
        : (_openBlock(), _createBlock(_component_JudgeStep, {
            key: 1,
            currentJudgeStep: _ctx.currentJudgeStep,
            judgeStepList: _ctx.judgeStepList
          }, null, 8, ["currentJudgeStep", "judgeStepList"]))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('message.lang')), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.time')), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('message.memory')), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.code')), 1)
    ]),
    (_ctx.isJudgeLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('message.loading')), 1))
      : (!_ctx.judgeRecord)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('message.noData')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.judgeRecord.programLanguage), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString((_ctx.judgeRecord.cpuTime / 100).toFixed(2)) + " sec ", 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.judgeRecord.memory) + " KB ", 1),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.judgeRecord.codeSize) + " B ", 1)
          ]))
  ]))
}